<div id="wrapper">
	@if (optionsCaption) {
	<select-box-item
		class="customizer-item"
		[ngClass]="{'is-selected': selected === null || selected === undefined}"
		[option]="null" 
		[editMode]="editMode" 
		[selected]="selected === null" 
		[imageClass]="imageClass" 
		[optionsCaption]="optionsCaption" 
		[variantOrModelIsNew]="variantOrModelIsNew" 
		[matchColor]="matchColor"
		(click)="setSelected(null)"
	></select-box-item>
	}

	<div id="select-box-container">
		@for (option of shownOptions; track $index) {
		<select-box-item
			class="customizer-item"
			[ngClass]="{'is-selected': optionIsSelected(option), 'accordion': isAccordion}"
			[attr.id]="option.Uuid"
			[option]="option"
			[selected]="optionIsSelected2(option)"
			[optionsDiscontinued]="optionsDiscontinued"
			[optionsText]="optionsText"
			[optionsDescription2]="optionsDescription2"
			[editMode]="editMode"
			[optionsImage]="optionsImage"
			[imageClass]="imageClass"
			[colorsAvailableForMatching]="colorsAvailableForMatching"
			[currentColor]="currentColor"
			[colorMatchMode]="colorMatchMode"
			[variantOrModelIsNew]="variantOrModelIsNew"
			[matchColor]="matchColor"
			(click)="setSelected(option)"
			(matchColorClicked)="matchColorsClicked()"
		></select-box-item>
		}
	</div>
</div>
